<template>
    <main class="dashboard">
        <Header @change-section="visibleSection = $event" :currentSection="visibleSection" :chartLoaded="chartLoaded" />
        <div v-if="has_conciliator" v-show="visibleSection == 'conciliador'" class="conciliador-container">
            <section class="dashboard-section consolidado-valores">
                <div class="container is-half">
                    <SectionHeader title="Resumen de tu salud financiera"
                        description="Mira en línea tus cuentas por cobrar, por pagar y sus vencimientos en una proyección de caja." />
                    <Consolidation :isVisible="visibleSection == 'conciliador'" @onChartRendered="onChartRendered" />
                </div>
            </section>
            <DashboardMainTabs class="my-6">
                <template v-slot:obligations>
                    <Obligations :isVisible="visibleSection == 'conciliador'" />
                </template>
                <template v-slot:stament>
                    <BankMovements />
                </template>
            </DashboardMainTabs>
            <section class="is-hidden-tablet my-4">
                <div class="notification is-info is-light py-5">
                    <h3 class="is-size-5 mb-2">Importante</h3>
                    <p>
                        Te recomendamos utilizar la versión de escritorio para
                        agregar nuevos documentos.
                    </p>
                </div>
            </section>
        </div>
        <DashboardBasic v-show="visibleSection == 'reporte'" :isVisible="visibleSection == 'reporte'"
            :chartLoaded="chartLoaded" />
        <DashboardFileUpload v-if="has_file_upload" v-show="visibleSection == 'fileUpload'" />
        <DashboardClassificator v-if="has_classificator" v-show="visibleSection == 'classificator'" />
        <div v-show="visibleSection == 'none'">
            <div class="notification is-info is-light py-5">
                <h3 class="is-size-5 mb-2">Importante</h3>
                <p>
                    Su usuario no tiene configurado acceso a ninguna funcionalidad de CFORemoto.
                    <br /><br />
                    Consulte al equipo de CFORemoto para solucionar este error.
                </p>
            </div>
        </div>
        <div v-show="visibleSection == ''" />
    </main>
</template>

<script>
import BankMovements from "@/components/bankMovements/BankMovements";
import Consolidation from "@/components/dashboard/consolidation/Consolidation";
import Header from "@/components/dashboard/Header";
import DashboardMainTabs from "@/components/dashboardMainTabs/DashboardMainTabs";
import Obligations from "@/components/obligations/Obligations";
import SectionHeader from "@/components/sectionHeader/SectionHeader";
import DashboardBasic from "@/views/DashboardBasic";
import DashboardClassificator from "@/views/DashboardClassificator";
import DashboardFileUpload from "@/views/DashboardFileUpload";
import { mapState } from "vuex";

export default {
    name: "Dashboard",
    components: {
        Consolidation,
        Header,
        Obligations,
        DashboardMainTabs,
        BankMovements,
        SectionHeader,
        DashboardBasic,
        DashboardFileUpload,
        DashboardClassificator,
    },
    methods: {
        onChartRendered() {
            this.chartLoaded = true;
        },
        setVisibleSectionFromUser(user) {
            this.visibleSection = 'none';
            if (user) {
                if (!user.has_conciliator && user.has_embedded_report) {
                    this.chartLoaded = true;
                }
                //order is important
                if (user.has_classificator) {
                    this.has_classificator = 'classificator';
                    this.visibleSection = 'classificator';
                }
                if (user.has_file_upload) {
                    this.has_file_upload = 'fileUpload';
                    this.visibleSection = 'fileUpload';
                }
                if (user.has_embedded_report) {
                    this.has_embedded_report = 'reporte';
                    this.visibleSection = 'reporte';
                }
                if (user.has_conciliator) {
                    this.has_conciliator = 'conciliador';
                    this.visibleSection = 'conciliador';
                }
            }
        },
    },
    watch: {
        user(newValue) {
            if (newValue.user_info_loaded) {
                this.setVisibleSectionFromUser(newValue);
            }
        }
    },
    computed: {
        ...mapState("userAuth", ["user"]),
    },
    data() {
        return {
            visibleSection: '',
            has_conciliator: false,
            has_embedded_report: false,
            has_file_upload: false,
            has_classificator: false,
            chartLoaded: false,
        };
    },
};

</script>
